import { PropertyItemListCombinedProps } from './types';

const usePresenter = (props: PropertyItemListCombinedProps): PropertyItemListCombinedProps => {
  return props;
};

export default usePresenter;
